// in src/users.js
import React from 'react';
import {SimpleForm, Create, TextInput, ReferenceArrayInput, SelectArrayInput, ChipField, required} from 'react-admin';
import {makeStyles, Theme} from '@material-ui/core';
import {HASH_TAG, HASHTAG_RECOMMEND_LIST} from '../../consts/Names';
import {Validators, trimValidation} from '../../consts/Validators';
import {Messages} from '../../consts/Messages';

const useStyles = makeStyles((theme: Theme) => ({
   form: {
      display: 'flex',
      flexDirection: 'column'
   },
   formContainer: {
      padding: '1em 1em 1em 1em'
   },
   textFld: {
      width: '300px',
      marginTop: '1em'
   },
   imageFld: {
      display: 'flex',
      width: '300px'
   }
}));

const validateStock = [required(), Validators.minValue(3, Messages.MIN_VALUE), trimValidation];

export const HashTagRecommendCreate = (props) => {
   const {theme} = props;
   const classes = useStyles(theme);

   return (
      <Create {...props} title="Create tags list for recommended">
         <SimpleForm className={classes.formContainer} redirect="list">
            <TextInput className={classes.textFld} label="List Name" source={HASHTAG_RECOMMEND_LIST.name} validate={validateStock} />
            <ReferenceArrayInput className={classes.textFld} label="Related tags" reference={HASH_TAG.SOURCE} perPage={1000}
             source={HASHTAG_RECOMMEND_LIST.ids} validate={[required()]}>
               <SelectArrayInput>
                  <ChipField />
               </SelectArrayInput>
            </ReferenceArrayInput>
         </SimpleForm>
      </Create>
   );
};
